import {
    http
} from "@/assets/utils/api";

/**
 * 课程列表
 */
export const getCourseList = (params) => http.get('/yymCourse/list', {
    params,
    custom: {
        isAuth: false
    }
});

/**
 * 课程详情
 */
export const getCourseDetail = (courseId) => http.get('/yymCourse/getById/' + courseId, {
    custom: {
        isAuth: false
    }
});

/**
 * 课程设置信息
 */
export const setCourseInfo = (courseId) => http.get('/yymCourseSetting/getById/' + courseId, {
    custom: {
        isAuth: false
    }
});

/**
 * 课程章节列表
 */
export const getCourseChapter = (params) => http.get('/yymCourseChapter/getAll', {
    params
});

/**
 * 课程资料列表
 */
export const getCoursewareList = (params) => http.get('/yymDigitalBusiness/getListByCourseRe', {
    params
});

/**
 * 查询收藏关系
 */
export const getCollectInfo = (params) => http.get('/collect/getAssociatedIdsState', {
    params
});

/**
 * 收藏
 */
export const collectCourse = (data) => http.post('/collect/collect', data);

/**
 * 收藏课程列表
 */
export const getCollectCourseList = (params) => http.get('/yymCourse/getCollectList', {
    params
});

/**
 * 参与学习(免费课程)
 */
export const joinFreeCourse = (data) => http.post('/yymCourse/joinFreeCourse', data);

/**
 * 查询课程是否已参与学习
 */
export const hasAlreadyJoin = (courseId) => http.get('/yymCourseUser/hasAlreadyJoin/' + courseId);

/**
 * 课程下单
 */
export const placeOrder = (data) => http.post('/yymCourseOrder/order', data);

/**
 * 模拟支付
 */
export const tempPay = (data) => http.post('/yymCourseOrder/tempPay', data);

/**
 * 取消订单
 * @param {*} params 
 * @returns 
 */
export const cancelCourseOrder = (data) => http.post('/yymCourseOrder/cancel', data);

/**
 * 课程订单列表
 */
export const getCourseOrderList = (params) => http.get('/yymCourseOrder/list', {
    params
});

/**
 * 课程评价
 */
export const addCourseAppraise = (data) => http.post('/yymCourseAppraise/add', data);

/**
 * 课程评价列表
 */
export const getEvaluateList = (params) => http.get('/yymCourseAppraise/list', {
    params
});

/**
 * 评价点赞
 */
export const evaluateLike = (data) => http.post('/yymCourseCommentLike/like', data);

/**
 * 查询是否点赞
 */
export const checkIsLike = (data) => http.post('/yymCourseCommentLike/batchHasAlreadyLikes', data);

/**
 * 回复(主题&评价)
 */
export const addReply = (data) => http.post('/yymCourseCommentReply/add', data);

/**
 * 回复（回复对回复）
 */
export const addReplyToReply = (data) => http.post('/yymCourseCommentReply/addReply', data);

/**
 * 查询回复列表
 * @param {*} params 
 * @returns 
 */
export const getReplyList = (params) => http.get('/yymCourseCommentReply/list', {
    params
});

/**
 * 查询回复列表（限制展示数量）
 * @param {*} params 
 * @returns 
 */
export const getReplyListBySize = (params) => http.get('/yymCourseCommentReply/listSceneIdGroup', {
    params
});

/**
 * 我的课程列表
 */
export const getMyCourseList = (params) => http.get('/yymCourse/getMyJoinList', {
    params
});

/**
 * 课程讨论组（获取列表）
 */
export const getDiscussList = (params) => http.get('/yymCourseDiscuss/list', {
    params
});

/**
 * 课程讨论组（新增讨论）
 */
export const addDiscuss = (data) => http.post('/yymCourseDiscuss/add', data);

/**
 * 新增笔记
 */
export const addNote = (data) => http.post('/yymCourseNote/add', data);

/**
 * 获取笔记列表
 */
export const getNoteList = (params) => http.get('/yymCourseNote/getMyList', {
    params
});

/**
 * 删除笔记
 */
export const deleteNote = (id) => http.post('/yymCourseNote/delete/' + id);

/**
 * 修改笔记
 */
export const editNote = (data) => http.post('/yymCourseNote/edit', data);

/**
 * 课程公告列表
 */
export const getCourseNoticeList = (params) => http.get('/yymCourseNotice/list', {
    params
});

/**
 * 公告详情
 * @returns 
 */
export const getNoticeDetail = (noticeId) => http.get('/yymCourseNotice/getById/' + noticeId);

/**
 * 查询上架课程列表中学科
 */
export const getCourseSubjectList = () => http.get('/yymCourse/getCourseSubjectGroup');


/** ===========   四轮七阶   =========== */
/**
 * 获取轮次字典
 */
export const getRoundDict = () => http.get('/yymCourseScheme/getRoundDict');

/**
 * 获取方案列表
 * @param {*} params 
 * @returns 
 */
export const getSchemeByCourseId = (courseId) => http.get('/yymCourseScheme/getAllByCourseId/' + courseId);

/**
 * 章节阶段列表
 */
export const getCourseChapterNew = (params) => http.get('/yymCourseSchemeChapter/getAll', {
    params
});

/**
 * 阶段字典列表
 */
export const getPhaseList = () => http.get('/yymCourseScheme/getPhaseDict');

/**
 * 获取章节附件列表
 */
export const getFileList = (params) => http.get('/yymDigitalBusiness/getListByCourseChapterRe', {
    params
});

/**
 * 切换课程学习方案
 * @param {*} data 
 * @returns 
 */
export const changeCourseScheme = (data) => http.post('/yymCourseUserProgress/changeScheme', data);

/***
 * 获取作业列表
 */
export const getMyHomeworkList = (data) => http.post("/yymCourseQuestionExamPaper/getPaperList", data);

/**
 * 作业去完成
 */
export const goFinishHomework = (paperId) => http.get(`/yymCourseQuestionExamPaper/getPaperCount/${paperId}`);

/**
 * 作业开始作答
 */
export const getPaperInfo = (paperId) => http.get(`/yymCourseQuestionExamPaper/getByPaperId/${paperId}`);

/**
 * 作业提交
 */
export const submitPaperInfo = (data) => http.post('/examPaperRecord/savePaperRecord', data);

/**
 * 查询我的课程章节阶段学习进度
 */
export const getMyCourseChapterProgress = (params) => http.get('/yymCourseUserChapterProgress/getBySchemeChapterPhaseId', {
    params
});

/**
 * 主动触发学习进度结算更新（仅视频观看完成后调用该接口）
 */
export const settlementVideoSegment = (data) => http.post('/yymCourseUserChapterProgress/settlementVideoSegment', data);

/**
 * 查询我的课程学习进度
 */
export const getMyCourseProgress = (params) => http.get('/yymCourseUserProgress/getMyProgress', {
    params
});

/**
 * 获取闯关信息
 */
export const getChallengeInfo = (courseId, schemeId, roundId, phaseId, chapterId) => http.get(`/yymCourseQuestionExamPaper/getLevel/${courseId}/${schemeId}/${roundId}/${phaseId}/${chapterId}`);

/**
 * 批量查询课程学习进度
 */
export const getChapterProgress = (params) => http.get("/yymCourseUserChapterProgress/getChapterProgressCountResultsByCourseIds",{params});

/**
 * 伴学师列表
 */
export const getCompanionTeacher = (params) => http.get('/planner/tutor',{params});

/**
 * 规划师列表
 */
export const getPlannerTeacher = (params) => http.get('/planner/user',{params});

/**
 * 查询我的课程班级详情
 */
export const getClassRomeInfo = (params) => http.get('/yymCourseClass/getMyCourseClass',{params});

/**
 * 向伴学师提问
 */
export const askQuestionByTeacher = (data) => http.post('/yymAccompanyingQnaManagement/qna/add',data);

/**
 * 获取某个时间课程开课的章节列表
 */
export const getOpenChapterList= (params) => http.get('/yymCourse/getStudyChapterCalendarList',{params});

/**
 * 自定义作业答题卡（课堂）
 */
export const getCustomAnswerSheet = (type,id) => http.get(`/yymCourseQuestionAnswerCard/${type}/${id}`);  // type为1课堂作业，2课后作业，type为1时id为examId，2为homeworkId